import * as Sentry from '@sentry/browser';

// Frontend Sentry client. DSN is passed from Rails via a meta tag (rendered only when
// sentry_env? && SENTRY_PUBLIC_DSN is present -- see app/views/layouts/application.html.slim)
// rather than baked into the webpack build, since it varies per deployment environment.
// Imported first in entrypoints/application.js so it captures errors from the moment the app loads.
const dsn = document.querySelector('meta[name="sentry-public-dsn"]')?.getAttribute('content');
// Mirrors the backend's config.environment (see config/initializers/sentry.rb /
// ApplicationHelper#sentry_environment_meta_tag) so alpha/beta/prod stay distinguishable
// in Sentry even when SENTRY_PUBLIC_DSN is shared across deployments.
const environment = document.querySelector('meta[name="sentry-environment"]')?.getAttribute('content');

if (dsn) {
  Sentry.init({ dsn, environment: environment ?? undefined });
}

declare global {
  interface Window {
    EmSentry?: {
      setUser: (traits: Record<string, unknown>) => void;
    };
  }
}

window.EmSentry = {
  setUser: (traits) => {
    if (dsn) {
      Sentry.setUser(traits);
    }
  },
};
